
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"margin-top":"6px"},style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"60","style":"margin-top:6px","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M8 4a1 1 0 011 1v14a1 1 0 11-2 0V5a1 1 0 011-1zm8 0a1 1 0 011 1v14a1 1 0 11-2 0V5a1 1 0 011-1z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    